export enum TeamsThemeType {
	Contrast = "contrast",
	Dark = "dark",
	Default = "default",
}
